const KEY = 'auth0SignInError';

// The backend's 401 detail when Auth0 authenticated an identity that has no active Collective
// account (collective-backend hyke/auth/auth0/authentication.py). No renewed token changes it.
export const NO_ACCOUNT_DETAIL = 'No active Collective account for this identity.';

export const NO_ACCOUNT_MESSAGE = 'No Collective account found for this email address.';

// A failure with nothing more useful to tell the member than to try again.
export const SIGN_IN_FAILED_MESSAGE = 'We could not finish signing you in. Please try again.';

/**
 * What to tell a member whose sign-in a 401 ended. The same endpoint also answers 401 for an
 * invalid or expired token and for a request with no credentials, and those members do have an
 * account. DRF puts no code in the body, so the exact detail is the only signal; a distinct
 * backend code is the follow-up.
 */
export function messageForUnauthorized(detail: unknown): string {
    return detail === NO_ACCOUNT_DETAIL ? NO_ACCOUNT_MESSAGE : SIGN_IN_FAILED_MESSAGE;
}

// sessionStorage, not router state: router state is lost across the forced logout and
// Auth0's own that can lead to /login, yet kept across a reload, which would replay the
// failure instead of signing in again.
export function rememberSignInError(message: string): void {
    window.sessionStorage.setItem(KEY, message);
}

/** Read and clear, so a later visit does not replay a stale failure. */
export function consumeSignInError(): string | undefined {
    const message = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);

    return message ?? undefined;
}
